module.exports = __webpack_public_path__ + "static/jana-0de6985b17a6ce3190d3b62a9929878d.png";